// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"e44af5d5","372":"698a2c45","403":"7cfe499f","991":"4d3c9163"}[chunkId] + ".chunk.js";
};